const MAIN_MEASUREMENT_ID = 'G-QR4BWG74WB';
const FORM_PATHS = { contact: '/contact', mobile_demo: '/', desktop_inquiry: null };

// Call only after the existing form endpoint accepts a submission.
// No form contents, email, phone, company, or free text enter this event.
// Use the existing Google tag and consent settings; never block form success.
export default function trackServiceInquiry(formId) {
  if (!Object.prototype.hasOwnProperty.call(FORM_PATHS, formId)) return false;
  if (typeof window === 'undefined' ||
      !['databackfill.com', 'www.databackfill.com'].includes(window.location.hostname) ||
      typeof window.gtag !== 'function') return false;
  try {
    window.gtag('event', 'generate_lead', {
      send_to: MAIN_MEASUREMENT_ID,
      form_id: formId,
      lead_type: 'service_inquiry',
      // Avoid carrying query strings or fragments into this event's page URL.
      page_location: `https://databackfill.com${FORM_PATHS[formId] ?? window.location.pathname}`,
    });
    return true;
  } catch {
    return false;
  }
}
